import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ToastNotification {
    message: string;
    type: 'success' | 'achievement' | 'reward' | 'error';
    icon?: string;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private notificationSubject = new Subject<ToastNotification>();
    notifications$ = this.notificationSubject.asObservable();

    showNotification(notification: ToastNotification) {
        this.notificationSubject.next(notification);
    }
}